import React from "react";
import style from "./index.module.scss";
import { Dropdown, Icon, Menu } from "antd";
import classNames from "classnames";
import useBatchPicker from "../../../../utils/useBatchPicker";
import { termListAtom } from "../../../../store";
import { useAtomValue } from "jotai";

export default function BatchPicker() {
    const batchList = useAtomValue(termListAtom);
    const { batch, handleChangeBatch } = useBatchPicker();

    const menu = (
        <Menu className={style.menu}>
            {batchList?.map(item => (
                <Menu.Item
                    key={item.batchNo}
                    onClick={() => handleChangeBatch(item.batchNo)}
                    className={classNames(style.menuItem, {
                        [style.selected]: item.batchNo === batch
                    })}>
                    {item.batchName}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div className={style.root}>
            <Dropdown overlay={menu} className={style.dropdown}>
                <div>
                    {batchList?.find(item => item.batchNo === batch)?.batchName}{" "}
                    <Icon type="down" />
                </div>
            </Dropdown>
        </div>
    );
}
